import { getEndpoint } from './endpoints';

export default {
    state: {
        controlsList: [],
        sort: {},
        pagination: {
            currentPage: 1,
            perPage: 15,
            total: 0,
        },
        sorterFields: {},
        search: { motifTypes:null, folderNumber: null, dateOfVisit: null, street: null, requestType: null, status: null, dateOfVisitFrom: null, dateOfVisitTo: null },
    },
    mutations: {
        setControlsList(state, payload) {
            state.controlsList = payload;
        },
        initSearchForm(state) {
            state.search = { addressStreet: null, addressNumber: null, folderNumber: null, dateOfVisit: null, street: null, requestType: null, status: null, sorterFields: null };
            state.pagination.currentPage = 1;
        },
    },
    actions: {
        resetSearchControlsList({  state } ) {
            state.search = {};
        },
        async fetchControlsList({ commit, rootState, state }, payload) {
            
            let pageNum = payload && payload.page ? payload.page : state.pagination.currentPage;

            let params = { page: pageNum, per_page: state.pagination.perPage };

            if (payload && payload.sortField && payload.order) {
                params['sorterFields[]'] = payload.sortField + '=' + payload.order;
            }
            
            params.folderNumber = state.search.folderNumber;
            params.requestType = state.search.requestType;
            params.status = state.search.status;
            params.filterFields = [];
            params.context = [];

            if (state.search.folderNumber) {
                params.context.push("[type][]=folderNumber");
                params.context.push("[id][]=" + state.search.folderNumber);
            }

            if (state.search.dateOfVisit) {
                params.filterFields.push("dateOfVisit.keyword__EQ__[" + state.search.dateOfVisit + "]");
            }

            if (state.search.dateOfVisitFrom) {
                params.filterFields.push("dateOfVisit.keyword__EQGT__[" + state.search.dateOfVisitFrom + "]");
            }

            if (state.search.dateOfVisitTo) {
                params.filterFields.push("dateOfVisit.keyword__EQLT__[" + state.search.dateOfVisitTo + "]");
            }

            if (state.search.town) {
                params.filterFields.push("address.city.keyword__EQ__[" + state.search.town.code + "]");
            }

            if (state.search.addressStreet) {
                params.filterFields.push("address.street.keyword__EQ__[*" + state.search.addressStreet + "*]");
            }

            if (state.search.addressNumber) {
                params.filterFields.push("address.number__EQ__[" + state.search.addressNumber + "]");
            }

            if (state.search.motifTypes) {
                params.filterFields.push("typeOfControl.id.keyword__EQ__[" + state.search.motifTypes + "]");
            }

            if (state.search.protractor) {
                params.filterFields.push("protractor.keyword__EQ__[*" + state.search.protractor + "*]");
            }

            var endpoint = getEndpoint('controls').controlsList;
            const { data, headers } = await rootState.app.http.instance.get(endpoint, {
                params: params,
            });

            
            commit('setControlsList', data);
            commit('setPaginationOptions', { total: headers.total });
        },
    },
    getters: {
        getControlsList(state) {
            return state.controlsList;
        },
    },
};
